import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import VueNotification from 'vue-notification';
import Vuelidate from 'vuelidate'
import App from './App.vue';
import { router } from './_infrastructure';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import VueLoadingOverlay from 'vue-loading-overlay'

import './site.scss';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import 'vue-loading-overlay/dist/vue-loading.css';

import datePicker from 'vue-bootstrap-datetimepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import jQuery from "jquery";
import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/regular.css";
import "@fortawesome/fontawesome-free/css/solid.css";

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: "far fa-clock",
    date: "far fa-calendar",
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down",
    previous: "fas fa-chevron-left",
    next: "fas fa-chevron-right",
    today: "fas fa-calendar-check",
    clear: "far fa-trash-alt",
    close: "far fa-times-circle"
  }
});

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueNotification);
Vue.use(Vuelidate);
Vue.use(VueLoadingOverlay);
Vue.use(datePicker);

library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.filter('languageProficiency', function (value) {
  if (value == "0")
    return 'Beginner';
  if (value == "1")
    return 'Elementary';
  if (value == "2")
    return 'Intermediate';
  if (value == "3")
    return 'Upper-Intermediate';
  if (value == "4")
    return 'Advanced';
  if (value == "5")
    return 'Proficient';
  if(value == 6)
    return 'Pre-Intermediate';
  else return '';
})

Vue.filter('replaceDotsWithCommas', function (value) {
  value += "";
  return value.split(".").join(",");
})

Vue.config.productionTip = false;

const app = new Vue({
  router,
  render: h => h(App),
});

app.$mount('#app');